module.exports = "<div class=\"row\">\n  <div class=\"col-md-6\" *ngFor=\"let col of columnsNames | keyvalue\">\n    <div class=\"checkbox\">\n      <label>\n        <input\n          type=\"checkbox\"\n          [id]=\"col.key\"\n          (click)=\"changeColumn(col.key)\"\n          [checked]=\"filteredColumns[col.key]\"\n          class=\"custom-control-input\"\n        />\n        {{ col.value }}\n      </label>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/columns-filter/columns-filter.component.html
// module id = ./src/app/shared/columns-filter/columns-filter.component.html
// module chunks = main